import { InMemoryCache } from '@apollo/client';

export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        getErrorData: {
          read() {
            return {
              isGraphQLError: !!localStorage.getItem('errorGraphQL'),
              isNetworkError: !!localStorage.getItem('errorNetwork'),
            };
          },
        },
        getAuthData: {
          read() {
            return {
              isLoggedIn: !!localStorage.getItem('token'),
              loggedUser: localStorage.getItem('usuario'),
              loggedUserID: localStorage.getItem('usuarioId'),
              loggedUserAvatar: localStorage.getItem('avatar'),
              expiresTokenIn: localStorage.getItem('expirationDate'),
            };
          },
        },
      },
    },
  },
});
